import { render, staticRenderFns } from "./TPWFrame.vue?vue&type=template&id=4bdef7ab&"
import script from "./TPWFrame.vue?vue&type=script&lang=js&"
export * from "./TPWFrame.vue?vue&type=script&lang=js&"
import style0 from "./TPWFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports